import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import * as React from 'react';
export const SideTabContext = React.createContext({});
export const SideTabContextProvider = ({ children }) => {
    let defaultShowSideBar = true;
    if (!localStorage.getItem('showSideBar')) {
        localStorage.setItem('showSideBar', JSON.stringify(defaultShowSideBar));
    }
    else {
        defaultShowSideBar = JSON.parse(localStorage.getItem('showSideBar') || 'true');
    }
    const [showSideBar, setShowSideBar] = React.useState(defaultShowSideBar);
    React.useEffect(() => {
        localStorage.setItem('showSideBar', JSON.stringify(showSideBar));
    }, [showSideBar]);
    return (_jsx(SideTabContext.Provider, Object.assign({ value: { showSideBar, setShowSideBar } }, { children: children }), void 0));
};
